export const getHealthTips = async () => {
    return [
      {
        id: 1,
        tip: "Stay hydrated - Drink at least 8 glasses of water daily",
        color: "#e3f2fd",
        icon: '💧'
      },
      {
        id: 2,
        tip: "Exercise regularly - Aim for 30 minutes of physical activity daily",
        color: "#e8f5e9",
        icon: '🏃'
      },
      {
        id: 3,
        tip: "Get adequate sleep - 7-8 hours per night is recommended",
        color: "#f3e5f5",
        icon: '😴'
      },
      {
        id: 4,
        tip: "Eat a balanced diet rich in fruits and vegetables",
        color: "#fff3e0",
        icon: '🥗'
      },
      {
        id: 5,
        tip: "Practice mindfulness and stress management techniques",
        color: "#e0f7fa",
        icon: '🧘'
      },
      {
        id: 6,
        tip: "Take regular breaks when working - Follow the 20-20-20 rule",
        color: "#f5f5f5",
        icon: '⏰'
      },
      {
        id: 7,
        tip: "Include protein-rich foods in your meals",
        color: "#fce4ec",
        icon: '🥩'
      },
      {
        id: 8,
        tip: "Maintain good posture throughout the day",
        color: "#e8eaf6",
        icon: '🧍'
      },
      {
        id: 9,
        tip: "Stay socially connected with friends and family",
        color: "#fff8e1",
        icon: '👥'
      },
      {
        id: 10,
        tip: "Practice deep breathing exercises daily",
        color: "#e1f5fe",
        icon: '🫁'
      },
      {
        id: 11,
        tip: "Limit screen time before bedtime for better sleep",
        color: "#f3e5f5",
        icon: '📱'
      },
      {
        id: 12,
        tip: "Start your day with a healthy breakfast",
        color: "#fff3e0",
        icon: '🍳'
      },
      {
        id: 13,
        tip: "Take the stairs instead of the elevator when possible",
        color: "#e8f5e9",
        icon: '🪜'
      },
      {
        id: 14,
        tip: "Practice good dental hygiene - Brush and floss daily",
        color: "#e3f2fd",
        icon: '🦷'
      },
      {
        id: 15,
        tip: "Stay up to date with your vaccinations",
        color: "#e0f7fa",
        icon: '💉'
      },
      {
        id: 16,
        tip: "Schedule regular health check-ups",
        color: "#f5f5f5",
        icon: '👨‍⚕️'
      },
      {
        id: 17,
        tip: "Practice portion control during meals",
        color: "#fce4ec",
        icon: '🍽️'
      },
      {
        id: 18,
        tip: "Spend time outdoors to get natural vitamin D",
        color: "#fff8e1",
        icon: '☀️'
      },
      {
        id: 19,
        tip: "Keep your living space clean and organized",
        color: "#e8eaf6",
        icon: '🧹'
      },
      {
        id: 20,
        tip: "Listen to calming music to reduce stress",
        color: "#e1f5fe",
        icon: '🎵'
      },
      {
        id: 21,
        tip: "Try new healthy recipes regularly",
        color: "#e8f5e9",
        icon: '👩‍🍳'
      },
      {
        id: 22,
        tip: "Practice gratitude daily - Write down things you're thankful for",
        color: "#fff3e0",
        icon: '📝'
      },
      {
        id: 23,
        tip: "Stay hydrated during exercise",
        color: "#e3f2fd",
        icon: '🏋️'
      },
      {
        id: 24,
        tip: "Take time to stretch throughout the day",
        color: "#f3e5f5",
        icon: '🤸'
      },
      {
        id: 25,
        tip: "Maintain a consistent sleep schedule",
        color: "#e0f7fa",
        icon: '🌙'
      },
      {
        id: 26,
        tip: "Pack healthy snacks for work or travel",
        color: "#fce4ec",
        icon: '🍎'
      },
      {
        id: 27,
        tip: "Practice active listening in conversations",
        color: "#fff8e1",
        icon: '👂'
      },
      {
        id: 28,
        tip: "Take regular walks in nature",
        color: "#e8eaf6",
        icon: '🌳'
      },
      {
        id: 29,
        tip: "Learn stress-relief techniques like meditation",
        color: "#e1f5fe",
        icon: '🧠'
      },
      {
        id: 30,
        tip: "Stay informed about your family health history",
        color: "#f5f5f5",
        icon: '📋'
      }
    ];
  };
  
  
  
  